import React, { Component } from 'react';
import { apiGet } from '../../Api';
import AdminAPI from './AdminAPI';
import { ImageLoader } from '../Game/ImageLoader';
import { MEDIA_VARIANTS } from '../../media';

function TileMultiSelect({ label, options = [], values = [], onChange }) {
    return (
        <label>{label}:
            <select
                multiple
                value={values}
                onChange={(event) => onChange(
                    Array.from(event.target.selectedOptions, option => option.value),
                )}
            >
                {options.map(tile => (
                    <option key={tile.key} value={tile.key}>
                        {tile.name || tile.key} ({tile.key})
                    </option>
                ))}
            </select>
        </label>
    );
}

export default class EnemyDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            animatedImageFile: null,
            animatedImagePreviewUrl: '',
            enemies: null,
            selectedItem: null,
            loadedImages: {},
            loadedItems: {},
            requestedItem: false,
            loadedItems: {},
            itemFor: ""//Equipment or Loot
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.enemyId !== prevProps.enemyId || this.props.creatingNewEnemy !== prevProps.creatingNewEnemy) {
            this.setState({ imageFile: null, imagePreviewUrl: null, animatedImagePreviewUrl: null, animatedImageFile: null });
            this.getEnemy();

        }

        if (this.props.selectedItem && this.props.selectedItem !== this.state.selectedItem) {
            let enemy = this.state.enemies;
            if (enemy) {
                if (this.state.itemFor === "Equipment") {
                    if (!enemy.equipment) {
                        enemy.equipment = { equipment: [] };
                    }
                    else {
                        if (enemy.equipment.equipment) {
                            const fetchedItems = this.state.loadedItems;
                            enemy.equipment.equipment.map(async (obj) => {
                                const item = await this.getItem(obj.itemId);
                                fetchedItems[obj.itemId] = item;
                            });
                            this.setState({ loadedItems: fetchedItems });
                        }
                    }
                    enemy.equipment.equipment.push({ itemType: this.props.selectedItem.type, itemId: this.props.selectedItem.id })
                    this.setState({ selectedItem: this.props.selectedItem });
                }
                else if (this.state.itemFor === "Loot") {
                    if (!enemy.loot) {
                        enemy.loot = [];
                    }
                    else {
                        if (enemy.loot) {
                            const fetchedItems = this.state.loadedItems;
                            enemy.loot.map(async (obj) => {
                                const item = await this.getItem(obj.itemId);
                                fetchedItems[obj.itemId] = item;
                            });
                            this.setState({ loadedItems: fetchedItems });
                        }
                    }
                    enemy.loot.push({ itemId: this.props.selectedItem.id })
                    this.setState({ selectedItem: this.props.selectedItem });
                }
            }
        }
    }


    getEnemy = async () => {
        if (this.props.enemyId != null) {
            if (this.props.enemyId === "") {
                this.setState({
                    enemies: {
                        name: "",
                        flavourText: "",
                        visualDescription: "",
                        enemyType: "",
                        sequence: 0,
                        keyId: "",
                        xpRequired: 0,
                        levelOverride: null,
                        minimumPlayerLevel: 1,
                        spawnWeightOverride: null,
                        isAggressive: true,
                        awarenessRangeTiles: 3,
                        pursuitIntervalSeconds: 2,
                        roamingRadiusTiles: 0,
                        roamingHabitat: null,
                    },
                    imageFile: null,
                    imagePreviewUrl: "",
                });
            } else {
                const response = await apiGet("/enemy/" + this.props.enemyId);
                if (response.ok) {
                    const curr = await response.json();
                    this.setState({ enemies: curr });
                    if (curr.imageId) {
                        this.setState({ imagePreviewUrl: await AdminAPI.fetchImage(curr.imageId) });
                    }
                    if (curr.equipment?.equipment) {
                        curr.equipment.equipment.forEach(async (obj) => {
                            const item = this.state.loadedItems[obj.itemId];
                            if (!item) {
                                const newItem = await AdminAPI.getItem(obj.itemId);
                                // Use functional form of setState to ensure state is correctly updated
                                var loadedItems = this.state.loadedItems;
                                loadedItems[obj.itemId] = newItem;
                                this.setState({ loadedItems: loadedItems });
                            }
                        });
                    }
                }
            }
        } else {
            this.setState({ enemies: null });
        }
    }





    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (name === "levelOverride" || name === "spawnWeightOverride") {
            if (event.target.value === "") {
                value = null;
            } else {
                const parsed = name === "levelOverride"
                    ? Number.parseInt(event.target.value, 10)
                    : Number.parseFloat(event.target.value);
                value = Number.isFinite(parsed) ? parsed : null;
            }
        } else if (
            name === "minimumPlayerLevel"
            || name === "awarenessRangeTiles"
            || name === "pursuitIntervalSeconds"
            || name === "roamingRadiusTiles"
        ) {
            const parsed = Number.parseInt(event.target.value, 10);
            value = Number.isFinite(parsed)
                ? parsed
                : name === "awarenessRangeTiles"
                    ? 3
                    : name === "pursuitIntervalSeconds" ? 2 : 0;
        }
        const enemies = { ...this.state.enemies, [name]: value };
        this.setState({ enemies });
    };

    handleHabitatToggle = (event) => {
        const roamingHabitat = event.target.checked ? {
            allowedBaseKeys: [],
            allowedDetailKeysAny: [],
            near: null,
        } : null;
        this.setState(({ enemies }) => ({
            enemies: { ...enemies, roamingHabitat },
        }));
    };

    handleHabitatKeys = (field, values) => {
        this.setState(({ enemies }) => ({
            enemies: {
                ...enemies,
                roamingHabitat: {
                    ...enemies.roamingHabitat,
                    [field]: values,
                },
            },
        }));
    };

    handleNearToggle = (event) => {
        const near = event.target.checked ? {
            baseKeys: [],
            detailKeysAny: [],
            maxManhattanDistance: 1,
        } : null;
        this.setState(({ enemies }) => ({
            enemies: {
                ...enemies,
                roamingHabitat: {
                    ...enemies.roamingHabitat,
                    near,
                },
            },
        }));
    };

    handleNearKeys = (field, values) => {
        this.setState(({ enemies }) => ({
            enemies: {
                ...enemies,
                roamingHabitat: {
                    ...enemies.roamingHabitat,
                    near: {
                        ...enemies.roamingHabitat.near,
                        [field]: values,
                    },
                },
            },
        }));
    };

    handleNearDistance = (event) => {
        const maxManhattanDistance = Number.parseInt(event.target.value, 10);
        this.setState(({ enemies }) => ({
            enemies: {
                ...enemies,
                roamingHabitat: {
                    ...enemies.roamingHabitat,
                    near: {
                        ...enemies.roamingHabitat.near,
                        maxManhattanDistance: Number.isFinite(maxManhattanDistance)
                            ? maxManhattanDistance
                            : 1,
                    },
                },
            },
        }));
    };





    handleImageChange = async (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = async () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
            const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.entity.v1');
            if (assetId) {
                const enemies = { ...this.state.enemies, imageId: assetId };
                this.setState({ enemies });
            }

        };

        reader.readAsDataURL(file);


    };

    handleAnimatedMediaChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.entityVideo.v1');
        if (assetId) {
            this.setState((prev) => ({
                enemies: { ...prev.enemies, animatedMediaId: assetId },
            }));
        }
    };











    showItemPopup = (event) => {
        if (event.target.id == "AddEquipment")
            this.setState({ itemFor: "Equipment" });
        else if (event.target.id == "AddLoot") {
            this.setState({ itemFor: "Loot" });
        }
        this.props.showItemPopup();
    }

    removeItem = (event) => {
        event.stopPropagation();
        let enemies = { ...this.state.enemies };  // Make a shallow copy
        const targetValue = event.target.value.trim();
        console.log("Target value:", targetValue);

        enemies.equipment.equipment = enemies.equipment.equipment.filter(x => {
            // console.log("Comparing item:", x.itemId.trim(), "with", targetValue);
            // console.log(x.itemId.trim() !== targetValue);
            if (x.itemId)
                return x.itemId.trim() !== targetValue;
            else
                return false;

        });

        this.setState({ enemies });
    }

    render() {
        const {
            regions,
            onUpdate,
            onDelete,
            onCreate,
            creatingNewEnemy,
            onCancelCreate,
            enemyTypes,
            baseTiles = [],
            detailTiles = [],
        } = this.props;
        const { enemies, imagePreviewUrl, loadedItems } = this.state;

        if (!enemies || enemies == null) return <div>Select a enemies to see details</div>;

        return (
            <div className='admin_details'>
                <label>Id:
                    <input type="text" name="name" value={enemies.id} />
                </label>
                <label>Name:
                    <input type="text" name="name" value={enemies.name} onChange={this.handleInputChange} />
                </label>
                <label>FlavourText:
                    <textarea type="text" name="flavourText" value={enemies.flavourText} onChange={this.handleInputChange} />
                </label>
                <label>Visual Description:
                    <textarea type="text" name="visualDescription" value={enemies.visualDescription} onChange={this.handleInputChange} />
                </label>
                <label>Image:
                    <input type="file" onChange={this.handleImageChange} />
                    {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" className='adminPreviewImage' />}
                </label>
                <label>Animated media:
                    <input type="file" accept="video/*" onChange={this.handleAnimatedMediaChange} />
                </label>
                {(enemies.animatedMediaId || enemies.animatedImageId) && (
                    <ImageLoader
                        className="adminPreviewImage"
                        imageId={enemies.imageId}
                        animatedMediaId={enemies.animatedMediaId || enemies.animatedImageId}
                        variant={MEDIA_VARIANTS.PICTURE}
                        alt="Enemy media preview"
                    />
                )}
                <label>BaseHP:
                    <input type="number" name="baseHP" value={enemies?.baseHP} onChange={this.handleInputChange} />
                </label>
                <label>BaseDmg:
                    <input type="number" name="baseDmg" value={enemies?.baseDmg} onChange={this.handleInputChange} />
                </label>


                <label>Region:
                    <select name="regionId" value={enemies.regionId || ""} onChange={this.handleInputChange}>
                        <option value="">Select a Region</option>
                        {regions.map(region => (
                            <option key={region.id} value={region.id}>{region.name}</option>
                        ))}
                    </select>
                </label>
                <label>Level Override:
                    <input
                        type="number"
                        min="1"
                        step="1"
                        name="levelOverride"
                        value={enemies.levelOverride ?? ""}
                        onChange={this.handleInputChange}
                    />
                    <small>Leave blank to use the selected region's level.</small>
                </label>
                <label>Minimum Player Level:
                    <input
                        type="number"
                        min="1"
                        step="1"
                        name="minimumPlayerLevel"
                        value={enemies.minimumPlayerLevel ?? 1}
                        onChange={this.handleInputChange}
                    />
                    <small>The enemy cannot be selected below this player level.</small>
                </label>
                <label>Spawn Weight Override:
                    <input
                        type="number"
                        min="0.01"
                        step="0.01"
                        name="spawnWeightOverride"
                        value={enemies.spawnWeightOverride ?? ""}
                        onChange={this.handleInputChange}
                    />
                    <small>Leave blank for the normal spawn weight; higher values make this enemy more common.</small>
                </label>
                <label>Aggressive:
                    <input
                        type="checkbox"
                        name="isAggressive"
                        checked={enemies.isAggressive ?? true}
                        onChange={this.handleInputChange}
                    />
                    <small>Aggressive enemies pursue eligible players; passive enemies only fight on contact.</small>
                </label>
                <label>Awareness Range:
                    <input
                        type="number"
                        min="0"
                        max="20"
                        step="1"
                        name="awarenessRangeTiles"
                        value={enemies.awarenessRangeTiles ?? 3}
                        onChange={this.handleInputChange}
                    />
                    <small>Reachable path distance in tiles. Zero disables pursuit.</small>
                </label>
                <label>Pursuit Interval:
                    <input
                        type="number"
                        min="1"
                        max="60"
                        step="1"
                        name="pursuitIntervalSeconds"
                        value={enemies.pursuitIntervalSeconds ?? 2}
                        onChange={this.handleInputChange}
                    />
                    <small>Seconds between pursuit steps. Unaware enemies wander every four seconds.</small>
                </label>
                <label>Roaming Radius:
                    <input
                        type="number"
                        min="0"
                        max="200"
                        step="1"
                        name="roamingRadiusTiles"
                        value={enemies.roamingRadiusTiles ?? 0}
                        onChange={this.handleInputChange}
                    />
                    <small>Maximum Manhattan distance from the spawn or Champion placement. Zero allows the whole region.</small>
                </label>
                <label>
                    <input
                        type="checkbox"
                        checked={Boolean(enemies.roamingHabitat)}
                        onChange={this.handleHabitatToggle}
                    />
                    Restrict spawn and patrol targets by habitat
                </label>
                {enemies.roamingHabitat && (
                    <fieldset>
                        <legend>Roaming Habitat</legend>
                        <TileMultiSelect
                            label="Allowed base tiles"
                            options={baseTiles}
                            values={enemies.roamingHabitat.allowedBaseKeys || []}
                            onChange={(values) => this.handleHabitatKeys('allowedBaseKeys', values)}
                        />
                        <TileMultiSelect
                            label="Allowed detail tiles"
                            options={detailTiles}
                            values={enemies.roamingHabitat.allowedDetailKeysAny || []}
                            onChange={(values) => this.handleHabitatKeys('allowedDetailKeysAny', values)}
                        />
                        <label>
                            <input
                                type="checkbox"
                                checked={Boolean(enemies.roamingHabitat.near)}
                                onChange={this.handleNearToggle}
                            />
                            Require nearby terrain or details
                        </label>
                        {enemies.roamingHabitat.near && (
                            <>
                                <TileMultiSelect
                                    label="Near base tiles"
                                    options={baseTiles}
                                    values={enemies.roamingHabitat.near.baseKeys || []}
                                    onChange={(values) => this.handleNearKeys('baseKeys', values)}
                                />
                                <TileMultiSelect
                                    label="Near detail tiles"
                                    options={detailTiles}
                                    values={enemies.roamingHabitat.near.detailKeysAny || []}
                                    onChange={(values) => this.handleNearKeys('detailKeysAny', values)}
                                />
                                <label>Near distance:
                                    <input
                                        type="number"
                                        min="1"
                                        max="200"
                                        step="1"
                                        value={enemies.roamingHabitat.near.maxManhattanDistance ?? 1}
                                        onChange={this.handleNearDistance}
                                    />
                                </label>
                            </>
                        )}
                    </fieldset>
                )}
                <label className='labelBackground1'>
                    EnemyType:
                    <select
                        name="enemyType"
                        value={enemies.enemyType}
                        onChange={this.handleInputChange}
                    >
                        <option key="" value=""></option>
                        <option key={-1} value={null}></option>
                        {enemyTypes.map((obj, index) =>
                            <option key={index} value={obj.id}>{obj.name}</option>
                        )}

                    </select>
                </label>
                <label className='labelBackground2'>Equipment:
                    <div className='row'>
                        {enemies.equipment?.equipment?.map((obj, index) => {



                            return (
                                <div key={obj.itemId} className='gridItem'>
                                    <div className='image-wrapper'>
                                        <ImageLoader
                                            className="adminweapon"
                                            imageId={loadedItems[obj.itemId]?.imageId}
                                            itemId={obj.itemId}
                                            animatedMediaId={loadedItems[obj.itemId]?.animatedMediaId || loadedItems[obj.itemId]?.animatedImageId}
                                            variant={MEDIA_VARIANTS.MODAL}
                                            alt=""
                                        />


                                        <button className='floatingDelTopRight' value={obj.itemId} onMouseUp={this.removeItem}>X</button>
                                    </div>
                                    <p>Name: {loadedItems[obj.itemId]?.name}</p>
                                </div>
                            );

                        })}
                    </div>

                    <div><label>Add another equipment:</label>
                        <button id="AddEquipment" onClick={this.showItemPopup}>Add</button>
                    </div>
                </label >


                {creatingNewEnemy ?
                    <div>
                        {/* Form to create a new enemies, similar to the update form... */}
                        <button className="button-primary" onClick={() => onCreate(enemies)}>Create</button>
                        <button className="button-secondary" onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button className="button-primary" onClick={() => onUpdate(enemies)}>Update</button>
                        <button className="button-critical" onClick={() => onDelete(enemies)}>Delete</button>

                    </div>

                }


            </div>
        );


    }

}
